module.exports = "<div class=nn-base-img ng-class=className() ng-style=styles()><img ng-if=!noLazy alt=\"{{ alt }}\" lazy-img=\"{{ src }}\"><img ng-if=noLazy alt=\"{{ alt }}\" ng-src=\"{{ src }}\"></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-base-components/nn-base-img/nn-base-img.directive.html
// module id = 955
// module chunks = 0